import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/router';
import { ThemeProvider } from './app/context/ThemeContext';
import { updateCoordinator } from './pwa/updateCoordinator';
import { db } from './data/db';
import './styles/fonts.css';
import './styles/index.css';

import { syncQueueService } from './data/sync/syncQueueService';
import { eventService } from './data/events/eventService';

if (typeof window !== 'undefined') {
  (window as unknown as { __callfoundry_db?: unknown }).__callfoundry_db = db;
  (window as unknown as { __callfoundry_syncQueue?: unknown }).__callfoundry_syncQueue = syncQueueService;
  (window as unknown as { __callfoundry_eventService?: unknown }).__callfoundry_eventService = eventService;
}

// Register PWA service worker with interaction-sensitive update coordinator
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  import('virtual:pwa-register')
    .then(({ registerSW }) => {
      const updateSW = registerSW({
        onNeedRefresh() {
          updateCoordinator.registerPendingUpdate(async () => {
            await updateSW(true);
          });
        },
        onOfflineReady() {
          console.info('[CallFoundry PWA] Application ready for offline performance training.');
        },
      });
    })
    .catch((err) => {
      console.warn('[CallFoundry PWA] Service worker registration deferred:', err);
    });
}

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </React.StrictMode>
  );
}
